import React, { useState, useMemo, createContext, useCallback, useEffect } from 'react';
import { USER_INFO_KEY,IS_USER_LOGIN, YJ_ACCESS_TOKEN, IS_MOBILE_LOGIN,ORIGINAL_URL } from '../configuration'
import { LINE_LOGIN_URI, LINE_LOGIN_CLIENT_ID, LINE_REDIRECT_URL ,LINE_CHANNEL_ID,LINE_REDIRECT_URI,COOKIE_NAME,LINE_CHANNEL_SECRET,COOKIE_GET_LINETOKEN_NAME,COOKIE_LOGUT_NAME} from '../configuration'
import { getUserInfo } from '../apis/member'
import { useQuery, QueryCache } from 'react-query';
// new query user info
import { UserInfoData, LocationData } from '../types/CustomType';
import UserService from '../apis/UserService';
import { getLocationSession, clearLocationSession, saveLocationSession } from '../utils/mapNavigationUtils';
import { message } from 'antd';
import { AUTH_FORCE_LOGOUT_EVENT, ForceLogoutEventDetail, redirectToLineLogin } from '../utils/authManager';
import { handleLineLogin } from '../utils/lineAuthUtils';
import { devLog } from '../utils/devLogger';

interface UserContextType {
  userInfo: UserInfoData;
  isLogin: boolean;
  isMobileLogin: boolean;
  isUpdateInfo:boolean;
  lineToken:string;
  currentLocation: LocationData | null;
  isLocating: boolean;
  updateUserInfo: () => void;
  setMobileLogin: (status: boolean) => void;
  setUserLogin: (status: boolean) => void;
  setUpdateInfo: (status: boolean) => void;
  setLineToken: (toke: string) => void;
  setCurrentLocation: (location: LocationData) => void;
  triggerAutoLocation: () => Promise<LocationData>;
  refreshLocation: () => Promise<LocationData>;
  checkLocationNeeded: () => boolean;
  logout: () => void;
}

const AuthContext = createContext<UserContextType>({
  userInfo : {
    id : '',
    nick_name: '',
    email: '',
    profile_picture:'',
    phone:'',birthday:'',
    gender:'',
    address_city:'',
    address_township:'',
    tour_check:false,
    permission:'',
    defaultVouchers:[],
    notExchangeVouchers:[],
    exchangeVouchers:[],
    expiredVouchers:[],
    publicLayaltyCards:[],
    voucherCount:0,
  },
  lineToken:'',
  isLogin: false,
  isMobileLogin: false,
  isUpdateInfo:false,
  currentLocation: null,
  isLocating: false,
  updateUserInfo: () => {devLog('No member information'); },
  setMobileLogin: () => { devLog('Set mobile status'); },
  setUserLogin: () => { devLog('Set login status'); },
  setUpdateInfo: () => { devLog('Set update info status'); },
  setLineToken: () => { devLog('Set line token'); },
  setCurrentLocation: () => { devLog('Set current location'); },
  triggerAutoLocation: () => { devLog('Trigger auto location'); return Promise.resolve({} as LocationData); },
  refreshLocation: () => { devLog('Refresh location'); return Promise.resolve({} as LocationData); },
  checkLocationNeeded: () => { devLog('Check location needed'); return false; },
  logout: () => { devLog('Sign out'); },
  
  
});

const emptyUserInfo: UserInfoData = {
  id: '',
  nick_name: '',
  email: '',
  profile_picture: '',
  phone: '',
  birthday: '',
  gender: '',
  address_city: '',
  address_township: '',
  tour_check: false,
  permission: '',
  defaultVouchers: [],
  notExchangeVouchers: [],
  exchangeVouchers: [],
  expiredVouchers: [],
  publicLayaltyCards: [],
  voucherCount: 0,
};

export const AuthContextProvider = (props: React.PropsWithChildren) => {

  let defaultUserInfo = { ...emptyUserInfo };

  //若已存在...
  const userInfoValue = localStorage.getItem(USER_INFO_KEY);
  const yjAccessTonken = localStorage.getItem(YJ_ACCESS_TOKEN);
  if (userInfoValue != 'undefined' && userInfoValue && yjAccessTonken) { 
    defaultUserInfo = JSON.parse(userInfoValue);
  }

  const mobileLoginLocalstorage = localStorage.getItem(IS_MOBILE_LOGIN);
  const userLoginLocalstorage = localStorage.getItem(IS_USER_LOGIN);
  //const [userInfo, setUserInfo] = useState<IUpdateUserInfo>(defaultUserInfo);

  const [userInfo, setUserInfo] = useState<UserInfoData>(defaultUserInfo);
  

  const [isLogin, setIsLogin] = useState<boolean>(
    userLoginLocalstorage ? JSON.parse(userLoginLocalstorage) : false
  );

  const [isMobileLogin, setIsMobileLogin] = useState<boolean>(
    mobileLoginLocalstorage ? JSON.parse(mobileLoginLocalstorage) : false
  );

  const [isUpdateInfo, setUpdateInfo] = useState<boolean>(false);
  const [lineToken, setLineToken] = useState<string>("");

  // 自動定位相關狀態
  const [currentLocation, setCurrentLocationState] = useState<LocationData | null>(
    getLocationSession()
  );
  const [isLocating, setIsLocating] = useState<boolean>(false);
 

  const setMobileLogin = useCallback((status: boolean) => {
    setIsMobileLogin(status);
    localStorage.setItem(IS_MOBILE_LOGIN, JSON.stringify(status));
  }, []);

  const setUserLogin = useCallback((status: boolean) => {
    setIsLogin(status);
    localStorage.setItem(IS_USER_LOGIN, JSON.stringify(status));
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(USER_INFO_KEY);
    localStorage.removeItem(YJ_ACCESS_TOKEN);
    localStorage.removeItem(IS_MOBILE_LOGIN);
    localStorage.removeItem(IS_USER_LOGIN);
    setUserInfo(emptyUserInfo);
    setUserLogin(false);
    setMobileLogin(false);
    setLineToken('');
    setUpdateInfo(false);
    clearLocationSession();
    setCurrentLocationState(null);
    setIsLocating(false);
    localStorage.setItem(ORIGINAL_URL, "/mobile");
  }, [setMobileLogin, setUserLogin]);
  const updateUserInfo = useCallback(async () => {

    queryUserInfoByAuth();

  }, [setUserInfo]);


  const setLineTokens = (token: string) => {
    setLineToken(token)
  }

  // 自動定位相關方法
  const setCurrentLocation = useCallback((location: LocationData) => {
    setCurrentLocationState(location);
    saveLocationSession(location);
    devLog('📍 AuthContext: 位置已更新', {
      來源: location.source,
      座標: `${location.lat}, ${location.lng}`,
      精度: location.accuracy ? `${location.accuracy}m` : '未知'
    });
  }, []);

  const triggerAutoLocation = useCallback(async (): Promise<LocationData> => {
    devLog('🎯 AuthContext: 開始自動定位...');
    setIsLocating(true);

    try {
      // 動態導入 useAutoLocation Hook
      const { requestAutoLocation } = await import('../utils/mapNavigationUtils');
      const locationData = await requestAutoLocation();

      setCurrentLocation(locationData);
      devLog('✅ AuthContext: 自動定位完成');

      return locationData;
    } catch (error) {
      console.error('❌ AuthContext: 自動定位失敗', error);

      // 失敗時使用預設位置
      const { getYongJingDefaultLocation } = await import('../utils/mapNavigationUtils');
      const fallbackLocation = getYongJingDefaultLocation();
      fallbackLocation.source = 'fallback';

      setCurrentLocation(fallbackLocation);
      return fallbackLocation;
    } finally {
      setIsLocating(false);
    }
  }, [setCurrentLocation]);

  const refreshLocation = useCallback(async (): Promise<LocationData> => {
    devLog('🔄 AuthContext: 重新定位...');

    // 清除舊的位置資訊
    clearLocationSession();
    setCurrentLocationState(null);

    // 觸發新的定位
    return await triggerAutoLocation();
  }, [triggerAutoLocation]);

  const checkLocationNeeded = useCallback((): boolean => {
    // 檢查是否需要進行自動定位
    // 條件：用戶已登入且尚未在本次會話中獲取位置
    if (!isMobileLogin) return false;

    const sessionLocation = getLocationSession();
    const needed = sessionLocation === null;

    devLog('🔍 AuthContext: 檢查是否需要定位', {
      登入狀態: isMobileLogin,
      現有位置: sessionLocation ? '有' : '無',
      需要定位: needed
    });

    return needed;
  }, [isMobileLogin]);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    let redirectTimer: number | undefined;

    const handleForceLogout = (event: Event) => {
      const customEvent = event as CustomEvent<ForceLogoutEventDetail>;
      const detail = customEvent.detail;
      const messageText = detail?.message ?? '登入狀態已過期，請重新登入。';

      logout();

      if (messageText) {
        message.warning(messageText, 2);
      }

      const redirectDelay = 1000;
      redirectTimer = window.setTimeout(() => {
        handleLineLogin(
          () => { window.location.reload(); },
          () => { redirectToLineLogin(detail?.state); },
        );
      }, redirectDelay);
    };

    window.addEventListener(AUTH_FORCE_LOGOUT_EVENT, handleForceLogout as EventListener);

    return () => {
      if (redirectTimer !== undefined) {
        window.clearTimeout(redirectTimer);
      }
      window.removeEventListener(AUTH_FORCE_LOGOUT_EVENT, handleForceLogout as EventListener);
    };
  }, [logout]);

  const { refetch: queryUserInfoByAuth } = useQuery<UserInfoData, Error>(
    `queryUserInfo`,
    async () => await UserService.getUserInfoData(),
    {
      enabled: false,
      onSuccess: (res) => {
        // devLog("更新資訊...."+res);
        if(res && res.id!=undefined){
          // devLog("更新資訊...."+JSON.stringify(res));
          // 儲存 user info
          localStorage.setItem(USER_INFO_KEY, JSON.stringify(res));
          setUserInfo(res);
          // 儲存 login 狀態
          localStorage.setItem(IS_USER_LOGIN, JSON.stringify(true));
          // setUserLogin(true);
          setUpdateInfo(true);
          setMobileLogin(true);

        }
        else {
          handleLineLogin((yjToken) => { setMobileLogin(true); });
        }

      },

      onError: (err: any) => {
        devLog(err);
        handleLineLogin((yjToken) => { setMobileLogin(true); });
      }
    }
  );


  const value = useMemo(
    () => ({
      userInfo: userInfo,
      isLogin : isLogin,
      isMobileLogin: isMobileLogin,
      isUpdateInfo: isUpdateInfo,
      lineToken:lineToken,
      currentLocation: currentLocation,
      isLocating: isLocating,
      updateUserInfo:updateUserInfo,
      setUserLogin : setUserLogin,
      setMobileLogin: setMobileLogin,
      setUpdateInfo: setUpdateInfo,
      setCurrentLocation: setCurrentLocation,
      triggerAutoLocation: triggerAutoLocation,
      refreshLocation: refreshLocation,
      checkLocationNeeded: checkLocationNeeded,
      logout: logout,
      setLineToken : setLineTokens,
    }),
    [userInfo, updateUserInfo, logout, isMobileLogin, setMobileLogin,isLogin, setUserLogin,isUpdateInfo,setUpdateInfo,lineToken,setLineToken, currentLocation, isLocating, setCurrentLocation, triggerAutoLocation, refreshLocation, checkLocationNeeded],
  );

  return <AuthContext.Provider value={value}>{(props.children)}</AuthContext.Provider>;
};

export default AuthContext;
